import whatsNewHTML from './whatsNewComponent.html';

class WhatsNewCtrl {
  constructor(Authentication, WhatsNewService, $element, $scope, $sce) {
    'ngInject';

    Object.assign(this, { Authentication, WhatsNewService, $element, $scope, $sce });
  }

  async $onInit() {
    this.$element.on('click', (event) => {
      if (event.target.href) {
        this.$scope.$evalAsync(() => {
          this.WhatsNewService.closeSidebar();
        });
      }
    });

    this.WhatsNewService.onSidebarStateChange((opened) => {
      if (opened) {
        this.$element.addClass('shown');
      } else {
        this.$element.removeClass('shown');
      }
    });
  }

  close() {
    this.WhatsNewService.closeSidebar();
  }

  get data() {
    return this.WhatsNewService.data;
  }
}

export default {
  templateUrl: whatsNewHTML,
  controller: WhatsNewCtrl,
  controllerAs: 'ctrl',
};
